export const translate = {
  udpate: {
    fr: 'Mise à jour le',
    en: 'Last updated on',
    es: 'Actualizado el',
    de: 'Aktualisiert am',
  },
};
